/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Coordinate,
    CoordinateFromJSON,
    CoordinateFromJSONTyped,
    CoordinateToJSON,
    WorkTime,
    WorkTimeFromJSON,
    WorkTimeFromJSONTyped,
    WorkTimeToJSON,
} from './';

/**
 * 
 * @export
 * @interface SiteContactInfo
 */
export interface SiteContactInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteContactInfo
     */
    phones: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SiteContactInfo
     */
    address: string;
    /**
     * 
     * @type {Array<WorkTime>}
     * @memberof SiteContactInfo
     */
    workTime: Array<WorkTime>;
    /**
     * 
     * @type {Coordinate}
     * @memberof SiteContactInfo
     */
    officeCoordinates: Coordinate;
    /**
     * 
     * @type {Coordinate}
     * @memberof SiteContactInfo
     */
    parkingCoordinates: Coordinate;
}

export function SiteContactInfoFromJSON(json: any): SiteContactInfo {
    return SiteContactInfoFromJSONTyped(json, false);
}

export function SiteContactInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteContactInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phones': json['phones'],
        'address': json['address'],
        'workTime': ((json['workTime'] as Array<any>).map(WorkTimeFromJSON)),
        'officeCoordinates': CoordinateFromJSON(json['officeCoordinates']),
        'parkingCoordinates': CoordinateFromJSON(json['parkingCoordinates']),
    };
}

export function SiteContactInfoToJSON(value?: SiteContactInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phones': value.phones,
        'address': value.address,
        'workTime': ((value.workTime as Array<any>).map(WorkTimeToJSON)),
        'officeCoordinates': CoordinateToJSON(value.officeCoordinates),
        'parkingCoordinates': CoordinateToJSON(value.parkingCoordinates),
    };
}


